// École Nid Douillet - Payments Page
// Page for managing payments

import React from 'react';

const PaymentsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-soft p-6">
        <h1 className="text-2xl font-bold text-neutral-900 mb-4">
          Gestion des paiements
        </h1>
        <p className="text-neutral-600">
          Cette page permettra de gérer les paiements, générer des reçus 
          et suivre les échéances.
        </p>
        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-800">
            🚧 Page en cours de développement
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentsPage;
